<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">ユニークキーリスト</div>
        </div>

        <a class="c-btn c-btn--blue u-w250" :href="uploadUrl">
          <p class="c-btn__text">リストをアップロード</p>
        </a>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <div
            class="p-message-result__data"
            :class="{ 'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }"
          >
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">ユニークキーリストがありません。CSV をアップロードして作成してください</div>
            </div>
            <table class="c-table">
              <thead>
                <tr>
                  <th class="c-table__cell--center">リスト名</th>
                  <th class="c-table__cell--center u-w120">キー数</th>
                  <th class="c-table__cell--center u-w180">登録日時</th>
                  <th class="c-table__cell--center u-w180">登録者</th>
                  <th class="c-table__cell--center u-w90"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="list in lists" :key="list.list_id" class="unique-key-list-row">
                  <td class="c-table__cell">
                    <a class="unique-key-list-name" :href="reviewUrl(list)">{{ list.list_name }}</a>
                  </td>
                  <td class="c-table__cell c-table__cell--right">{{ list.key_count.toLocaleString() }}</td>
                  <td class="c-table__cell c-table__cell--center">{{ getDisplayDateTime(list.create_date) }}</td>
                  <td class="c-table__cell c-table__cell--center">{{ list.create_user_name }}</td>
                  <td class="c-table__cell c-table__cell--center">
                    <button type="button" class="c-btn c-btn--gray u-w70 u-h32 u-fs--s" @click="onDeleteClick(list)">
                      削除
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <control-modal
      ref="refDeleteModal"
      classes="c-modal--message-delete"
      title="以下のリストを削除してもよろしいですか?"
      :body="deleteModalBody"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active="deletingList !== null"
      :on-close-click="onCloseDeleteModal"
      :on-cancel-click="onCloseDeleteModal"
      :on-enter-click="onEnterDeleteModal"
    />

    <error-modal :is-active="errorMessage !== ''" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
  },
  data() {
    return {
      lists: [],
      paginationInfo: null,
      page: 1,
      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      deletingList: null,
      errorMessage: '',
      uploadUrl: '/coins-admin/unique-key-list/upload',
    };
  },
  computed: {
    deleteModalBody: function () {
      if (!this.deletingList) {
        return '';
      }
      // 配信中・配信済みの配信はリストの複製を持つので影響しない. 下書き・配信待ちの配信が使っていればサーバーが断る
      return `リスト : ${this.deletingList.list_name}（下書き・配信待ちの配信に使われている間は削除できません）`;
    },
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      this.isLoading = true;
      this.isLoaded = false;
      axios
        .get('/api/unique-key-list/list', { params: { page: this.page } })
        .then((res) => {
          // 最後のページの最後の1件を消すなどでページが無くなったら、残っている最後のページを取り直す
          if (res.data.lists.data.length < 1 && this.page > res.data.lists.last_page) {
            this.page = res.data.lists.last_page;
            this.loadData();
            return;
          }
          this.lists = res.data.lists.data;
          this.paginationInfo = res.data.lists;
          this.isLoading = false;
          this.isLoaded = true;
          this.isEmpty = this.lists.length < 1;
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isLoading = false;
          this.errorMessage = 'ユニークキーリストの取得に失敗しました。再度お試しください。';
        });
    },
    reviewUrl: function (list) {
      return '/coins-admin/unique-key-list/review?list_id=' + list.list_id;
    },
    onPageClick: function (page) {
      this.page = page;
      this.loadData();
    },
    onDeleteClick: function (list) {
      this.deletingList = list;
    },
    onCloseDeleteModal: function () {
      this.deletingList = null;
      this.$refs.refDeleteModal.resetErrorMessage();
    },
    onEnterDeleteModal: function () {
      this.$refs.refDeleteModal.showLoader();
      axios
        .post('/api/unique-key-list/delete', { list_id: this.deletingList.list_id })
        .then((res) => {
          this.$refs.refDeleteModal.hideLoader();
          if (!this.handleResponse(res, false)) {
            this.$refs.refDeleteModal.showErrorMessage(res.data.message);
            return;
          }
          this.deletingList = null;
          this.loadData();
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.$refs.refDeleteModal.hideLoader();
          this.$refs.refDeleteModal.showErrorMessage('削除に失敗しました。再度お試しください。');
        });
    },
    onCloseErrorModal: function () {
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped>
.unique-key-list-name {
  color: #1d6fdc;
  text-decoration: underline;
  word-break: break-all;
}
</style>
